const intervalId = setInterval(() => {
if (window.tlFreeGiftOffer && window.tlCartGoalEmbed) {
    clearInterval(intervalId);

    const originalCheckIsGift = window.tlCartGoalEmbed.checkIsGift;

    window.tlCartGoalEmbed.checkIsGift = function (item) {
    if (item?.properties && Object.keys(item.properties).length) {
        if (
        item.properties["_salepify-advanced-fg"] || 
        item.properties["_salepify-embed"] || 
        item.properties["_salepify-bogo"]
        ) {
        return true;
        }
    }

    return originalCheckIsGift.call(this, item);
    };
}
}, 100);
setTimeout(() => clearInterval(intervalId), 3000);

document.addEventListener('click', (event) => {
    const cartIcon = event.target.closest('.icon--mrparker-cart');
    if (!cartIcon) return;

    if (window.tlCartGoalEmbed) {
        setTimeout(() => {
            window.tlCartGoalEmbed.renderAllCartGoals()
        }, 2000)
    }

});